<form  #form="ngForm">
  @for (identification of formIdentifications(); let idx = $index; track $index) {
    <app-layout-row>
      <app-layout-column [width]="12">
        <div class="inputandmessage-container">
          <div class="typeandvalue">
            <app-checkbox [name]="'selected-' + identification.IdentificationType.Id" [caption]="identification.IdentificationType.Name" [ngModel]="identification.Selected" [readonly]="isReadOnly(identification)"></app-checkbox>
            <app-textbox [name]="'identificationValue-' + identification.IdentificationType.Id" caption="Value" [ngModel]="identification.IdentificationValue" required [disabled]="isDisabled(identification)" [readonly]="isReadOnly(identification)"></app-textbox>
            <app-onboarding-comments-icon [disabled]="!allowConversation() || isDisabled(identification) || !hasConversationId(identification)" (clicked)="toggleConversation($safeNavigationMigration(identification?.ConversationId), null)"  [hasUnreadMessages]="hasUnreadMessages($safeNavigationMigration(identification?.ConversationId))"></app-onboarding-comments-icon>
          </div>

          @if (identification?.ConversationId && identification?.ConversationId===conversationToShow()?.Id) {
            <app-onboarding-comments-container title="Comments" [autoRefreshEnabled]="autoRefreshEnabled()" (toggleAutoRefreshClicked)="toggleAutoRefresh()" (closeClicked)="toggleConversation($safeNavigationMigration(identification?.ConversationId), null)">
              <app-conversation [conversation]="conversationToShow()" [readonly]="readonlyConversation()" (postNewMessageClicked)="newComment($event, $safeNavigationMigration(conversationToShow()?.Id))"></app-conversation>
            </app-onboarding-comments-container>
          }
        </div>
      </app-layout-column>
    </app-layout-row>
  }

  @for (customIdentification of formCustomIdentifications(); let idx = $index; track $index) {
    <app-layout-row>
      <app-layout-column [width]="12">
        <div class="inputandmessage-container">
          <div class="customtypeandvalue">
            <app-textbox [name]="'customIdentificationType-' + idx" caption="Identification Type" [(ngModel)]="customIdentification.IdentificationType" required [readonly]="isReadOnly(customIdentification)"></app-textbox>
            <app-textbox [name]="'customIdentificationValue-' + idx" caption="Value" [(ngModel)]="customIdentification.IdentificationValue" required [readonly]="isReadOnly(customIdentification)"></app-textbox>
            <app-link iconClass="dx-icon-trash" (onClick)="removeCustomIdentification(idx)" [disabled]="isReadOnly(customIdentification)"></app-link>
            <app-onboarding-comments-icon [disabled]="!allowConversation() || !hasConversationId(customIdentification)" (clicked)="toggleConversation($safeNavigationMigration(customIdentification?.ConversationId), null)" [hasUnreadMessages]="hasUnreadMessages($safeNavigationMigration(customIdentification?.ConversationId))"></app-onboarding-comments-icon>
          </div>

          @if (customIdentification?.ConversationId && customIdentification?.ConversationId===conversationToShow()?.Id) {
            <app-onboarding-comments-container title="Comments" [autoRefreshEnabled]="autoRefreshEnabled()" (toggleAutoRefreshClicked)="toggleAutoRefresh()" (closeClicked)="toggleConversation($safeNavigationMigration(customIdentification?.ConversationId), null)">
              <app-conversation [conversation]="conversationToShow()" [readonly]="readonlyConversation()" (postNewMessageClicked)="newComment($event, $safeNavigationMigration(conversationToShow()?.Id))"></app-conversation>
            </app-onboarding-comments-container>
          }
        </div>
      </app-layout-column>
    </app-layout-row>
  }

  <app-layout-row>
    <app-layout-column [width]="12">
      @if (formCustomIdentifications().length === 0) {
        <p>Your identifier is not on the list?</p>
      }
      <app-link iconClass="dx-icon-add" (onClick)="addCustomIdentification()" [disabled]="readonly()">Add Additional Identification</app-link>
    </app-layout-column>
  </app-layout-row>
</form>